module.exports = __webpack_public_path__ + "img/sidebar-footer-trees.f59b3929.png";